import { UnorderedListElement } from '~/components/organism/PluginsEditor/types';
import getUpdatedBlockAttrs from '~/components/organism/PluginsEditor/utils/serialize/getUpdatedBlockAttrs';

/**
 * serializes the UnorderedListElement into html element
 * @param {UnorderedListElement} node - UnorderedListElement
 */
const serialize = (node: UnorderedListElement, children: string): string => {
  const attrs = getUpdatedBlockAttrs(node);

  return `<ul${attrs ? ` ${attrs}` : ''}>${children}</ul>`;
};

export default serialize;
